/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import ConfirmationModal from '@/components/shared/ConfirmationModal'
import { Component, Vue } from 'vue-property-decorator'
import { RuleSetVO } from '@/valueObjects/RuleSetVO'
import YaraService from '@/services/YaraService'
import YaraServiceMixin from '@/services/YaraServiceMixin'
import Download from '@/utils/Download'
import MessageBox from '@/components/shared/MessageBox'
import {ERROR_MESSAGE_TYPE} from '@/utils/constants'

import {AnalysisService} from '@/services/AnalysisService'
import AnalysisServiceMixin from '@/services/AnalysisServiceMixin'
import {AnalysisVO} from '@/valueObjects/AnalysisVO'
import {displayLocalDate} from '@/utils/DateUtils'

import {Getter} from 'vuex-class'
import {UserVO} from '@/valueObjects/UserVO'

@Component({
    components: {
        ConfirmationModal,
        MessageBox,
    },
    mixins: [YaraServiceMixin , AnalysisServiceMixin],
})
export default class YaraRuleSetList extends Vue {
    private modalContent = {
        confirmButtonLabel: 'Delete',
        message: '',
        title: 'Confirm rule set removal',
    }
    private errorMessage = ''
    private messageType = ERROR_MESSAGE_TYPE
    private yaraService: YaraService
    private ruleSets: RuleSetVO[] = []
    private selectedRuleSet: RuleSetVO
    private isConfirmationVisible: boolean = false

    private analysisService: AnalysisService

    private analyses: AnalysisVO[] = []

    private way: number = 1
    private isAndroguardSelected: boolean = false
    private isMemoryDumpSelected: boolean = false
    private isHookSelected: boolean = false
    private isCodeSourceSelected: boolean = false

    public async updateType(){
        await this.loadRules()
        if (this.isAndroguardSelected){
        let filtered = this.ruleSets.filter(function(value,index,arr){
            return value.applyToAndroguard
        })
        this.ruleSets = filtered
        }

        if (this.isMemoryDumpSelected){
        let filtered = this.ruleSets.filter(function(value,index,arr){
            return value.applyToMemoryDump
        })
        this.ruleSets = filtered
        }

        if (this.isHookSelected){
        let filtered = this.ruleSets.filter(function(value,index,arr){
            return value.applyToNetwork
        })
        this.ruleSets = filtered
        }

        if (this.isCodeSourceSelected){
        let filtered = this.ruleSets.filter(function(value,index,arr){
            return value.applyToSourceCode
        })
        this.ruleSets = filtered
        }
    }
    public mounted() {
        this.loadRules()
    }

    public async loadRules(): Promise<void> {
        try {
            this.errorMessage = ''
            this.ruleSets = await this.yaraService.getRuleSets()
        } catch (e) {
            this.errorMessage = 'Yara rulesets loading failed. ' + e.errorMessage
        }
    }

    public addRule() {
        this.$router.push({ name: 'add_yararuleset'})
    }

    public async getArtefact(): Promise<void> {
        try {
            const data = await this.yaraService.getArtefact()
            Download.makeDownloadLink(data, `rule_sets.zip`)
        } catch (e) {
            this.errorMessage = 'Analysis artefacts loading failed. ' + e.errorMessage
        }
    }

    private confirmRuleSetDeletion(ruleSet: RuleSetVO) {
        this.selectedRuleSet = ruleSet
        this.modalContent.message = `You will delete the rule set "${ruleSet.name}". This cannot be undone.`
        this.isConfirmationVisible = true
    }


    private cancelModal() {
        this.isConfirmationVisible = false
    }

    private confirmModal() {
        this.isConfirmationVisible = false
        this.deleteSelectedRuleSet()
    }

    private async deleteSelectedRuleSet(): Promise<void> {
        try {
            await this.yaraService.deleteRuleSet(this.selectedRuleSet)
            this.selectedRuleSet = null
            this.loadRules()
        } catch (e) {
            this.errorMessage = `An error prevented to delete the Yara rule set: ${e.errorMessage}`
        }
    }

    private clearErrorMessage() {
        this.errorMessage = ''
    }

    private getLasTimeSeen(ruleSet: RuleSetVO): string {
        if (ruleSet.lastTimeSeen == null) {
            return ''
        } else {
            return ruleSet.lastTimeSeen.toString()
        }
    }

    private getOccurence(ruleSet: RuleSetVO): number {
        return ruleSet.nbOccurence
    }

    private sort_occurence(){
        //console.log("Sort by apk number");
        this.ruleSets.sort((n1:any,n2:any)=> {
            if(n1.nbOccurence > n2.nbOccurence){
                return -this.way
            }
            if (n1.nbOccurence < n2.nbOccurence){
                return this.way
            }
            return 0
        })
        this.way = this.way *-1
    }

    private getType(ruleSet: RuleSetVO): string {
        let text =""
        if (ruleSet.applyToAndroguard)
            text+= "Androguard "
        if (ruleSet.applyToMemoryDump)
            text+= "Memory_Dump "
        if (ruleSet.applyToNetwork)
            text+= "Hook "
        if (ruleSet.applyToSourceCode)
            text+= "Code_Source "
        return text
    }
}
